import { useAuth } from 'pages/auth/hooks/useAuth'
import { usePreferenceApi } from 'hooks/use-preference-api/usePreferenceApi'
import { useThemeSwitch } from 'hooks/theme'
import { useState } from 'react'

export const useUpdateModePreference = () => {
  const { updatePreference } = usePreferenceApi()
  const { userPreference, setPreference } = useAuth()
  const { mode, switchTheme } = useThemeSwitch()
  const [loadingPreference, setLoadingPreference] = useState(false)

  const handleModeChange = async () => {
    try {
      setLoadingPreference(true)
      switchTheme()
      if (userPreference) {
        const updatedPreference = await updatePreference(
          {
            ...userPreference,
            darkMode: mode === 'dark' ? true : false
          },
          setLoadingPreference
        )
        setPreference(updatedPreference)
        setLoadingPreference(false)
      }
      setLoadingPreference(false)
    } catch (err) {
      setLoadingPreference(false)
    }
  }

  return {
    handleModeChange,
    loadingPreference,
    setLoadingPreference
  } as const
}